var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Guides",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#0090d0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-1",
    cx: 60,
    cy: 60,
    r: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    className: "cls-2",
    d: "M985.19,1760.4L973.37,1736a4.51,4.51,0,0,1-.46-2v-15.91a1.38,1.38,0,0,0-1.39-1.39H957.07a1.38,1.38,0,0,0-1.39,1.39v16.38a2.45,2.45,0,0,1-.31,1.24l-11.82,24.72a3.69,3.69,0,0,0,3.32,5.25h35.07A3.66,3.66,0,0,0,985,1764,3.85,3.85,0,0,0,985.19,1760.4Zm-27.35-23.56a5.18,5.18,0,0,0,.54-2.39v-15.06h11.74V1734a7.56,7.56,0,0,0,.7,3.17l5.79,11.74H952.12Zm24.88,25.65a0.89,0.89,0,0,1-.85.46h-35a1.13,1.13,0,0,1-.85-0.46,1.12,1.12,0,0,1-.08-0.93l4.79-10h27.12l4.87,10A0.91,0.91,0,0,1,982.72,1762.49Z",
    transform: "translate(-904.37 -1681.17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.4deafe2897bfe410a5c28c0670edd9fa.svg";
export { ForwardRef as ReactComponent };